module.exports = __webpack_public_path__ + "images/stop_point_arrived.a1158eb639c8c52fa47308bf6a55d181.png";